const Auth = {
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  VERIFY_INVITE_TOKEN: 'VERIFY_INVITE_TOKEN',
  VERIFY_INVITE_TOKEN_SUCCESS: 'VERIFY_INVITE_TOKEN_SUCCESS',
  VERIFY_INVITE_TOKEN_ERROR: 'VERIFY_INVITE_TOKEN_ERROR',
  LOGIN: 'LOGIN_AUTH',
  LOGIN_SUCCESS: 'LOGIN_AUTH_SUCCESS',
  LOGIN_ERROR: 'LOGIN_AUTH_ERROR',
  LOGIN_2FA_REQUIRED: 'LOGIN_2FA_REQUIRED',
  LOGIN_2FA_INVALID: 'LOGIN_2FA_INVALID',
  LOGOUT: 'LOGOUT_AUTH',
  LOGOUT_SUCCESS: 'LOGOUT_AUTH_SUCCESS',
  ONELOGIN_LOGOUT: 'ONELOGIN_LOGOUT_AUTH',
  ONELOGIN_LOGOUT_SUCCESS: 'ONELOGIN_LOGOUT_AUTH_SUCCESS',
  ONELOGIN_LOGOUT_ERROR: 'ONELOGIN_LOGOUT_AUTH_ERROR',
  SIGNUP: 'SIGNUP_AUTH',
  SIGNUP_SUCCESS: 'SIGNUP_AUTH_SUCCESS',
  SIGNUP_ERROR: 'SIGNUP_AUTH_ERROR',
};

const BillPayments = {
  GET_BILL_PAYMENTS: 'GET_BILL_PAYMENTS',
  GET_BILL_PAYMENTS_ERROR: 'GET_BILL_PAYMENTS_ERROR',
  GET_BILL_PAYMENTS_SUCCESS: 'GET_BILL_PAYMENTS_SUCCESS',
  GET_BILL_PAYMENT: 'GET_BILL_PAYMENT',
  GET_BILL_PAYMENT_ERROR: 'GET_BILL_PAYMENT_ERROR',
  GET_BILL_PAYMENT_SUCCESS: 'GET_BILL_PAYMENT_SUCCESS',
};

const BillCredit = {
  GET_BILL_CREDIT: 'GET_BILL_CREDIT',
  GET_BILL_CREDIT_ERROR: 'GET_BILL_CREDIT_ERROR',
  GET_BILL_CREDIT_SUCCESS: 'GET_BILL_CREDIT_SUCCESS',
};

const BillCredits = {
  GET_BILL_CREDITS: 'GET_BILL_CREDITS',
  GET_BILL_CREDITS_ERROR: 'GET_BILL_CREDITS_ERROR',
  GET_BILL_CREDITS_SUCCESS: 'GET_BILL_CREDITS_SUCCESS',
  GET_BILL_CREDITS_EXPORT: 'GET_BILL_CREDITS_EXPORT',
  GET_BILL_CREDITS_EXPORT_ERROR: 'GET_BILL_CREDITS_EXPORT_ERROR',
  GET_BILL_CREDITS_EXPORT_SUCCESS: 'GET_BILL_CREDITS_EXPORT_SUCCESS',
};

const Block = {
  CREATE_BLOCK: 'CREATE_BLOCK',
  CREATE_BLOCK_ERROR: 'CREATE_BLOCK_ERROR',
  CREATE_BLOCK_SUCCESS: 'CREATE_BLOCK_SUCCESS',
  GET_BLOCK: 'GET_BLOCK',
  GET_BLOCK_ERROR: 'GET_BLOCK_ERROR',
  GET_BLOCK_SUCCESS: 'GET_BLOCK_SUCCESS',
  GET_BLOCKS: 'GET_BLOCKS',
  GET_BLOCKS_ERROR: 'GET_BLOCKS_ERROR',
  GET_BLOCKS_SUCCESS: 'GET_BLOCKS_SUCCESS',
  UPDATE_BLOCK: 'UPDATE_BLOCK',
  UPDATE_BLOCK_ERROR: 'UPDATE_BLOCK_ERROR',
  UPDATE_BLOCK_SUCCESS: 'UPDATE_BLOCK_SUCCESS',
  REMOVE_BLOCK: 'REMOVE_BLOCK',
  REMOVE_BLOCK_ERROR: 'REMOVE_BLOCK_ERROR',
  REMOVE_BLOCK_SUCCESS: 'REMOVE_BLOCK_SUCCESS',
};

const Delivery = {
  CREATE_DELIVERY: 'CREATE_DELIVERY',
  CREATE_DELIVERY_ERROR: 'CREATE_DELIVERY_ERROR',
  CREATE_DELIVERY_SUCCESS: 'CREATE_DELIVERY_SUCCESS',
  GET_AVAILABILITIES: 'GET_AVAILABILITIES',
  GET_AVAILABILITIES_ERROR: 'GET_AVAILABILITIES_ERROR',
  GET_AVAILABILITIES_SUCCESS: 'GET_AVAILABILITIES_SUCCESS',
  GET_DELIVERY: 'GET_DELIVERY',
  GET_DELIVERY_ERROR: 'GET_DELIVERY_ERROR',
  GET_DELIVERY_SUCCESS: 'GET_DELIVERY_SUCCESS',
  CHECK_IN_DELIVERY: 'CHECK_IN_DELIVERY',
  UPDATE_DELIVERY: 'UPDATE_DELIVERY',
  UPDATE_DELIVERY_ERROR: 'UPDATE_DELIVERY_ERROR',
  UPDATE_DELIVERY_SUCCESS: 'UPDATE_DELIVERY_SUCCESS',
  REMOVE_DELIVERY: 'REMOVE_DELIVERY',
  REMOVE_DELIVERY_ERROR: 'REMOVE_DELIVERY_ERROR',
  REMOVE_DELIVERY_SUCCESS: 'REMOVE_DELIVERY_SUCCESS',
};

const Deliveries = {
  GET_DELIVERIES: 'GET_DELIVERIES',
  GET_DELIVERIES_ERROR: 'GET_DELIVERIES_ERROR',
  GET_DELIVERIES_SUCCESS: 'GET_DELIVERIES_SUCCESS',
};

const Location = {
  CREATE_LOCATION: 'CREATE_LOCATION',
  CREATE_LOCATION_ERROR: 'CREATE_LOCATION_ERROR',
  CREATE_LOCATION_SUCCESS: 'CREATE_LOCATION_SUCCESS',
  GET_AVAILABILITIES: 'GET_AVAILABILITIES',
  GET_AVAILABILITIES_ERROR: 'GET_AVAILABILITIES_ERROR',
  GET_AVAILABILITIES_SUCCESS: 'GET_AVAILABILITIES_SUCCESS',
  GET_LOCATION: 'GET_LOCATION',
  GET_LOCATION_ERROR: 'GET_LOCATION_ERROR',
  GET_LOCATION_SUCCESS: 'GET_LOCATION_SUCCESS',
  UPDATE_LOCATION: 'UPDATE_LOCATION',
  UPDATE_LOCATION_ERROR: 'UPDATE_LOCATION_ERROR',
  UPDATE_LOCATION_SUCCESS: 'UPDATE_LOCATION_SUCCESS',
  REMOVE_LOCATION: 'REMOVE_LOCATION',
  REMOVE_LOCATION_ERROR: 'REMOVE_LOCATION_ERROR',
  REMOVE_LOCATION_SUCCESS: 'REMOVE_LOCATION_SUCCESS',
};

const LocationHour = {
  CREATE_LOCATION_HOUR: 'CREATE_LOCATION_HOUR',
  CREATE_LOCATION_HOUR_ERROR: 'CREATE_LOCATION_HOUR_ERROR',
  CREATE_LOCATION_HOUR_SUCCESS: 'CREATE_LOCATION_HOUR_SUCCESS',
  GET_LOCATION_HOUR: 'GET_LOCATION_HOUR',
  GET_LOCATION_HOUR_ERROR: 'GET_LOCATION_HOUR_ERROR',
  GET_LOCATION_HOUR_SUCCESS: 'GET_LOCATION_HOUR_SUCCESS',
  DELETE_LOCATION_HOUR: 'DELETE_LOCATION_HOUR',
  DELETE_LOCATION_HOUR_ERROR: 'DELETE_LOCATION_HOUR_ERROR',
  DELETE_LOCATION_HOUR_SUCCESS: 'DELETE_LOCATION_HOUR_SUCCESS',
  UPDATE_LOCATION_HOUR: 'UPDATE_LOCATION_HOUR',
  UPDATE_LOCATION_HOUR_ERROR: 'UPDATE_LOCATION_HOUR_ERROR',
  UPDATE_LOCATION_HOUR_SUCCESS: 'UPDATE_LOCATION_HOUR_SUCCESS',
};

const Locations = {
  GET_LOCATIONS: 'GET_LOCATIONS',
  GET_LOCATIONS_ERROR: 'GET_LOCATIONS_ERROR',
  GET_LOCATIONS_SUCCESS: 'GET_LOCATIONS_SUCCESS',
};

const PublicFiles = {
  GET_FILES: 'GET_FILES',
  GET_FILES_ERROR: 'GET_FILES_ERROR',
  GET_FILES_SUCCESS: 'GET_FILES_SUCCESS',
  UPLOAD_FILE: 'UPLOAD_FILE',
  UPLOAD_FILE_ERROR: 'UPLOAD_FILE_ERROR',
  UPLOAD_FILE_PROGRESS: 'UPLOAD_FILE_PROGRESS',
  UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
};

const PurchaseOrder = {
  GET_PURCHASE_ORDER: 'GET_PURCHASE_ORDER',
  GET_PURCHASE_ORDER_ERROR: 'GET_PURCHASE_ORDER_ERROR',
  GET_PURCHASE_ORDER_SUCCESS: 'GET_PURCHASE_ORDER_SUCCESS',
  ACCEPT_PURCHASE_ORDER: 'ACCEPT_PURCHASE_ORDER',
  ACCEPT_PURCHASE_ORDER_ERROR: 'ACCEPT_PURCHASE_ORDER_ERROR',
  ACCEPT_PURCHASE_ORDER_SUCCESS: 'ACCEPT_PURCHASE_ORDER_SUCCESS',
  REJECT_PURCHASE_ORDER: 'REJECT_PURCHASE_ORDER',
  REJECT_PURCHASE_ORDER_ERROR: 'REJECT_PURCHASE_ORDER_ERROR',
  REJECT_PURCHASE_ORDER_SUCCESS: 'REJECT_PURCHASE_ORDER_SUCCESS',
  UPLOAD_INVOICE: 'UPLOAD_INVOICE',
  UPLOAD_INVOICE_ERROR: 'UPLOAD_INVOICE_ERROR',
  UPLOAD_INVOICE_SUCCESS: 'UPLOAD_INVOICE_SUCCESS',
  UPLOAD_INVOICE_PROGRESS: 'UPLOAD_INVOICE_PROGRESS',
  UPLOAD_PACKING_LIST: 'UPLOAD_PACKING_LIST',
  UPLOAD_PACKING_LIST_ERROR: 'UPLOAD_PACKING_LIST_ERROR',
  UPLOAD_PACKING_LIST_SUCCESS: 'UPLOAD_PACKING_LIST_SUCCESS',
  UPLOAD_PACKING_LIST_PROGRESS: 'UPLOAD_PACKING_LIST_PROGRESS',
};

const PurchaseOrders = {
  GET_DELIVERABLE_PURCHASE_ORDERS: 'GET_DELIVERABLE_PURCHASE_ORDERS',
  GET_DELIVERABLE_PURCHASE_ORDERS_ERROR:
    'GET_DELIVERABLE_PURCHASE_ORDERS_ERROR',
  GET_DELIVERABLE_PURCHASE_ORDERS_SUCCESS:
    'GET_DELIVERABLE_PURCHASE_ORDERS_SUCCESS',
  GET_PURCHASE_ORDERS: 'GET_PURCHASE_ORDERS',
  GET_PURCHASE_ORDERS_ERROR: 'GET_PURCHASE_ORDERS_ERROR',
  GET_PURCHASE_ORDERS_SUCCESS: 'GET_PURCHASE_ORDERS_SUCCESS',
  ACCEPT_PURCHASE_ORDERS: 'ACCEPT_PURCHASE_ORDERS',
  ACCEPT_PURCHASE_ORDERS_ERROR: 'ACCEPT_PURCHASE_ORDERS_ERROR',
  ACCEPT_PURCHASE_ORDERS_SUCCESS: 'ACCEPT_PURCHASE_ORDERS_SUCCESS',
  REJECT_PURCHASE_ORDERS: 'REJECT_PURCHASE_ORDERS',
  REJECT_PURCHASE_ORDERS_ERROR: 'REJECT_PURCHASE_ORDERS_ERROR',
  REJECT_PURCHASE_ORDERS_SUCCESS: 'REJECT_PURCHASE_ORDERS_SUCCESS',
};

const User = {
  GET_CURRENT_USER: 'GET_CURRENT_USER',
  GET_CURRENT_ONELOGIN_USER: 'GET_CURRENT_ONELOGIN_USER',
  GET_CURRENT_USER_SUCCESS: 'GET_CURRENT_USER_SUCCESS',
  GET_CURRENT_ONELOGIN_USER_SUCCESS: 'GET_CURRENT_ONELOGIN_USER_SUCCESS',
  GET_CURRENT_USER_ERROR: 'GET_CURRENT_USER_ERROR',
  GET_USERS: 'GET_USERS',
  GET_USERS_ERROR: 'GET_USERS_ERROR',
  GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_USER_ERROR: 'UPDATE_USER_ERROR',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
};

const Vendor = {
  UPDATE_VENDOR: 'UPDATE_VENDOR',
  UPDATE_VENDOR_BANKING: 'UPDATE_VENDOR_BANKING',
  UPDATE_VENDOR_ERROR: 'UPDATE_VENDOR_ERROR',
  UPDATE_VENDOR_SUCCESS: 'UPDATE_VENDOR_SUCCESS',
  UPDATE_VENDOR_FILE_PROGRESS: 'UPDATE_VENDOR_FILE_PROGRESS',
  GET_PUBLIC_FILES: 'GET_PUBLIC_FILES',
  GET_PUBLIC_FILES_ERROR: 'GET_PUBLIC_FILES_ERROR',
  GET_PUBLIC_FILES_SUCCESS: 'GET_PUBLIC_FILES_SUCCESS',
  GET_VENDOR: 'GET_VENDOR',
  GET_VENDOR_ERROR: 'GET_VENDOR_ERROR',
  GET_VENDOR_SUCCESS: 'GET_VENDOR_SUCCESS',
  GET_VENDORS: 'GET_VENDORS',
  GET_VENDORS_ERROR: 'GET_VENDORS_ERROR',
  GET_VENDORS_SUCCESS: 'GET_VENDORS_SUCCESS',
  CREATE_VENDOR_CONTACT: 'CREATE_VENDOR_CONTACT',
  CREATE_VENDOR_CONTACT_ERROR: 'CREATE_VENDOR_CONTACT_ERROR',
  CREATE_VENDOR_CONTACT_SUCCESS: 'CREATE_VENDOR_CONTACT_SUCCESS',
  CREATE_VENDOR_NETSUITE: 'CREATE_VENDOR_NETSUITE',
  CREATE_VENDOR_NETSUITE_ERROR: 'CREATE_VENDOR_NETSUITE_ERROR',
  CREATE_VENDOR_NETSUITE_SUCCESS: 'CREATE_VENDOR_NETSUITE_SUCCESS',
  UPDATE_VENDOR_CONTACT: 'UPDATE_VENDOR_CONTACT',
  UPDATE_VENDOR_CONTACT_ERROR: 'UPDATE_VENDOR_CONTACT_ERROR',
  UPDATE_VENDOR_CONTACT_SUCCESS: 'UPDATE_VENDOR_CONTACT_SUCCESS',
  UPDATE_VENDOR_NETSUITE: 'UPDATE_VENDOR_NETSUITE',
  UPDATE_VENDOR_NETSUITE_ERROR: 'UPDATE_VENDOR_NETSUITE_ERROR',
  UPDATE_VENDOR_NETSUITE_SUCCESS: 'UPDATE_VENDOR_NETSUITE_SUCCESS',
  REMOVE_VENDOR_CONTACT: 'REMOVE_VENDOR_CONTACT',
  REMOVE_VENDOR_CONTACT_ERROR: 'REMOVE_VENDOR_CONTACT_ERROR',
  REMOVE_VENDOR_CONTACT_SUCCESS: 'REMOVE_VENDOR_CONTACT_SUCCESS',
  GET_VENDOR_DELIVERIES: 'GET_VENDOR_DELIVERIES',
  GET_VENDOR_DELIVERIES_ERROR: 'GET_VENDOR_DELIVERIES_ERROR',
  GET_VENDOR_DELIVERIES_SUCCESS: 'GET_VENDOR_DELIVERIES_SUCCESS',
  GET_VENDOR_DELIVERY: 'GET_VENDOR_DELIVERY',
  GET_VENDOR_DELIVERY_ERROR: 'GET_VENDOR_DELIVERY_ERROR',
  GET_VENDOR_DELIVERY_SUCCESS: 'GET_VENDOR_DELIVERY_SUCCESS',
  CREATE_VENDOR_DELIVERY: 'CREATE_VENDOR_DELIVERY',
  CREATE_VENDOR_DELIVERY_ERROR: 'CREATE_VENDOR_DELIVERY_ERROR',
  CREATE_VENDOR_DELIVERY_SUCCESS: 'CREATE_VENDOR_DELIVERY_SUCCESS',
  UPDATE_VENDOR_DELIVERY: 'UPDATE_VENDOR_DELIVERY',
  UPDATE_VENDOR_DELIVERY_ERROR: 'UPDATE_VENDOR_DELIVERY_ERROR',
  UPDATE_VENDOR_DELIVERY_SUCCESS: 'UPDATE_VENDOR_DELIVERY_SUCCESS',
  REMOVE_VENDOR_DELIVERY: 'REMOVE_VENDOR_DELIVERY',
  REMOVE_VENDOR_DELIVERY_ERROR: 'REMOVE_VENDOR_DELIVERY_ERROR',
  REMOVE_VENDOR_DELIVERY_SUCCESS: 'REMOVE_VENDOR_DELIVERY_SUCCESS',
  SUBMIT_VENDOR: 'SUBMIT_VENDOR',
  SUBMIT_VENDOR_ERROR: 'SUBMIT_VENDOR_ERROR',
  SUBMIT_VENDOR_SUCCESS: 'SUBMIT_VENDOR_SUCCESS',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
  UPDATE_LOADING: 'UPDATE_LOADING',
  SET_VENDOR: 'SET_VENDOR',
};

const VendorAttribution = {
  CREATE_VENDOR_ATTRIBUTES: 'CREATE_VENDOR_ATTRIBUTES',
  CREATE_VENDOR_ATTRIBUTES_ERROR: 'CREATE_VENDOR_ATTRIBUTES_ERROR',
  CREATE_VENDOR_ATTRIBUTES_SUCCESS: 'CREATE_VENDOR_ATTRIBUTES_SUCCESS',
  UPDATE_VENDOR_ATTRIBUTES: 'UPDATE_VENDOR_ATTRIBUTES',
  UPDATE_VENDOR_ATTRIBUTES_ERROR: 'UPDATE_VENDOR_ATTRIBUTES_ERROR',
  UPDATE_VENDOR_ATTRIBUTES_SUCCESS: 'UPDATE_VENDOR_ATTRIBUTES_SUCCESS',
};

const VendorBills = {
  GET_VENDOR_BILLS: 'GET_VENDOR_BILLS',
  GET_VENDOR_BILLS_ERROR: 'GET_VENDOR_BILLS_ERROR',
  GET_VENDOR_BILLS_SUCCESS: 'GET_VENDOR_BILLS_SUCCESS',
};

const VendorBill = {
  GET_VENDOR_BILL: 'GET_VENDOR_BILL',
  GET_VENDOR_BILL_ERROR: 'GET_VENDOR_BILL_ERROR',
  GET_VENDOR_BILL_SUCCESS: 'GET_VENDOR_BILL_SUCCESS',
};

const constants = {
  Auth,
  BillPayments,
  BillCredit,
  BillCredits,
  Block,
  Delivery,
  Deliveries,
  Location,
  LocationHour,
  Locations,
  PublicFiles,
  PurchaseOrder,
  PurchaseOrders,
  User,
  Vendor,
  VendorAttribution,
  VendorBills,
  VendorBill,
};

export default constants;
